import { render } from "./ChangePasswordCard.vue?vue&type=template&id=d30f080e&scoped=true&ts=true"
import script from "./ChangePasswordCard.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordCard.vue?vue&type=script&lang=ts"

import "./ChangePasswordCard.vue?vue&type=style&index=0&id=d30f080e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d30f080e"]])

export default __exports__